// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.concierge-reject-quotation-modal {
  max-width: 768px;
}
.concierge-reject-quotation-modal .ant-modal-content {
  padding: 32px 16px !important;
}
.concierge-reject-quotation-modal .note {
  min-height: 64px;
  margin-top: var(--spacing-small);
}
.concierge-reject-quotation-modal .actions {
  margin-top: var(--spacing-regular);
}
.concierge-reject-quotation-modal .actions .action-btn-group {
  display: flex;
  gap: var(--spacing-extra-small);
}
.concierge-reject-quotation-modal .actions .action-btn-group .btn-confirm.vert-button[disabled].ant-btn-default span {
  color: var(--color-neutral) !important;
}
.concierge-reject-quotation-modal .actions .action-btn-group .btn-confirm.vert-button:not([disabled]).ant-btn-highlight {
  background-color: var(--color-highlight) !important;
}
.concierge-reject-quotation-modal .actions .action-btn-group .btn-confirm.vert-button:not([disabled]).ant-btn-highlight:hover {
  background-color: var(--color-highlight-darker) !important;
}
.concierge-reject-quotation-modal .actions .action-btn-group .btn-confirm.vert-button:not([disabled]).ant-btn-default {
  border-color: var(--color-highlight) !important;
  color: var(--color-highlight) !important;
}
.concierge-reject-quotation-modal .actions .action-btn-group .btn-confirm.vert-button:not([disabled]).ant-btn-default:hover {
  border-color: var(--color-border) !important;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Concierge/Modals/RejectQuotationModal.less"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;AAFA;EAII,6BAAA;AACJ;AALA;EAQM,gBAAA;EACA,gCAAA;AAAN;AATA;EAaI,kCAAA;AADJ;AAZA;EAgBM,aAAA;EACA,+BAAA;AADN;AAhBA;EAqBU,sCAAA;AAFV;AAnBA;EA0BQ,mDAAA;AAJR;AAtBA;EA8BQ,0DAAA;AALR;AAzBA;EAkCQ,+CAAA;EACA,wCAAA;AANR;AA7BA;EAuCQ,4CAAA;AAPR","sourcesContent":[".concierge-reject-quotation-modal {\n  max-width: 768px;\n\n  .ant-modal-content {\n    padding: 32px 16px !important;\n  }\n\n  .note {\n      min-height: 64px;\n      margin-top: var(--spacing-small);\n  }\n\n  .actions {\n    margin-top: var(--spacing-regular);\n\n    .action-btn-group {\n      display: flex;\n      gap: var(--spacing-extra-small);\n\n      .btn-confirm.vert-button[disabled].ant-btn-default {\n        span {\n          color: var(--color-neutral) !important;\n        }\n      }\n    \n      .btn-confirm.vert-button:not([disabled]).ant-btn-highlight {\n        background-color: var(--color-highlight) !important;\n      }\n    \n      .btn-confirm.vert-button:not([disabled]).ant-btn-highlight:hover {\n        background-color: var(--color-highlight-darker) !important;\n      }\n    \n      .btn-confirm.vert-button:not([disabled]).ant-btn-default {\n        border-color: var(--color-highlight) !important;\n        color: var(--color-highlight) !important;\n      }\n    \n      .btn-confirm.vert-button:not([disabled]).ant-btn-default:hover {\n        border-color: var(--color-border) !important;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
